/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function house() {
  gsap.to(".siteHeader__house", {
    // opacity: "1",
    scrollTrigger: {
      trigger: ".who",
      start: "top 94px",
      onLeaveBack: () => {
        // This runs when scrolling down
        $('.siteHeader__house').removeClass('show');
      },
      onEnter: () => {
        // This runs when scrolling down
        $('.siteHeader__house').addClass('show');
      },
      // markers: true,
      // pin: true
    }
  });
}
